export default {
    RECEIVE_PLACES_OF_HARBOUR: 'RECEIVE_PLACES_OF_HARBOUR',
    RECEIVE_PLACE_OF_HARBOUR: 'RECEIVE_PLACE_OF_HARBOUR',
    DELETE_PLACE_OF_HARBOUR: 'DELETE_PLACE_OF_HARBOUR',

    // Types
    RESIDENT: 'resident',
    STOPOVER: 'stopover',
};
